import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { isCard, isEcheck, PaymentMethod } from '@egovsolutions/angular-payment-methods';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
    selector: 'app-payment-method-list-item',
    template: `
        <ng-template #actions>
            <div class="actions" *ngIf="removable">
                <app-icon-button [remove]="true" (click)="removalRequested.emit()" title="Remove">delete</app-icon-button>
            </div>
        </ng-template>
        <ng-template #content>
            <div class="payment-method-item-content" [class.selected]="selected">
                <div class="identifying-info" [ngClass]="{ card: paymentMethodIsCard$ | async, echeck: paymentMethodIsEcheck$ | async }">
                    <ng-container *ngIf="paymentMethodIsCard$ | async; else eCheckContent">
                        <app-payment-method-list-item-card-icon class="icon" [cardProvider]="(card$ | async)!.cardProvider"></app-payment-method-list-item-card-icon>
                        <div class="label">● ● ● ● &nbsp; {{ (card$ | async)!.cardLastFour }}</div>
                    </ng-container>
                    <ng-template #eCheckContent>
                        <app-payment-method-list-item-echeck-icon class="icon"></app-payment-method-list-item-echeck-icon>
                        <div class="label">
                            <span class="long-part">● ● ●</span>
                            ● ● {{ (eCheck$ | async)!.routingLastFour }}
                            &nbsp;/&nbsp;
                            <span class="long-part">● ● ●</span>
                            ● ● {{ (eCheck$ | async)!.accountLastFour }}
                        </div>
                    </ng-template>
                </div>
                <ng-container *ngTemplateOutlet="actions"></ng-container>
            </div>
        </ng-template>
        <button *ngIf="clickable; else content" mat-button (click)="itemSelected.emit()" type="button">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
        <ng-container *ngTemplateOutlet="actions"></ng-container>
    `,
    styleUrls: ['./payment-method-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodListItemComponent
{
    @Input() protected set paymentMethod(value: PaymentMethod) { this.paymentMethod$.next(value); } // Required
    protected readonly paymentMethod$ = new BehaviorSubject(undefined) as unknown as BehaviorSubject<PaymentMethod>;

    @Input() protected clickable = true;
    @Input() protected removable = false;
    @Input() protected selected = false;

    @Output() protected readonly itemSelected = new EventEmitter<void>();
    @Output() protected readonly removalRequested = new EventEmitter<void>();


    // Handy type checkers and casters

    protected readonly paymentMethodIsCard$ = this.paymentMethod$.pipe(map(isCard));
    protected readonly card$ = this.paymentMethod$.pipe(filter(isCard));

    protected readonly paymentMethodIsEcheck$ = this.paymentMethod$.pipe(map(isEcheck));
    protected readonly eCheck$ = this.paymentMethod$.pipe(filter(isEcheck));
}
